module.exports = "<template>\n\n    <sio-uploaded-file-input config.bind=\"field\" value.bind=\"field.value\"></sio-uploaded-file-input>\n\n</template>";